import {
  AssetTypeTranslationModel,
  DtoAssetTypeTranslationRequestInterface,
  DtoAssetTypeTranslationResponseInterface
} from "../interfaces";

export const mapAssetTypeTranslationFromDto = (dto: DtoAssetTypeTranslationResponseInterface): AssetTypeTranslationModel => {
  return {
    language: dto.language,
    assetName: dto.assetName,
    changedBy: dto.changedBy,
    changedTimestamp: dto.changedTimestamp
  };
};

export const mapAssetTypeTranslationFromDtoArray = (
  array: Array<DtoAssetTypeTranslationRequestInterface>
): Array<AssetTypeTranslationModel> => {
  const result: Array<AssetTypeTranslationModel> = [];

  array.forEach(dto => {
    result.push(mapAssetTypeTranslationFromDto(dto));
  });

  return result;
};

export const mapAssetTypeTranslationToDto = (model: AssetTypeTranslationModel): DtoAssetTypeTranslationRequestInterface => {
  return {
    language: model.language,
    assetName: model.assetName
  };
};

export const mapAssetTypeTranslationToDtoArray = (
  array: Array<AssetTypeTranslationModel>
): Array<DtoAssetTypeTranslationRequestInterface> => {
  const result: Array<DtoAssetTypeTranslationResponseInterface> = [];

  array.forEach(dto => {
    result.push(mapAssetTypeTranslationToDto(dto));
  });

  return result;
};
